import { render } from "./CommunitySelect.vue?vue&type=template&id=47adab59&scoped=true"
import script from "./CommunitySelect.vue?vue&type=script&lang=js"
export * from "./CommunitySelect.vue?vue&type=script&lang=js"

import "./CommunitySelect.vue?vue&type=style&index=0&id=47adab59&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47adab59"]])

export default __exports__